"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CATALOG_ATTRIBUTE_DISTRIBUTION = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_CATALOG_ATTRIBUTE_DISTRIBUTION = (0, gql_1.gql)(`
  query CatalogAttributeDistribution(
    $ids: [ID!]
    $productTreeId: ID!
    $productTreeNodeId: ID!
    $sort: AttributionOrderByInput
    $search: String
    $first: Int,
    $after: ID,
    $last: Int,
    $before: ID,
  ) {
    catalogs(ids: $ids) {
      edges {
        node {
          id
          statistics(productTreeId: $productTreeId, productTreeNodeIds: [$productTreeNodeId]) {
            attributes(
              sort: $sort,
              search: $search,
              first: $first,
              after: $after,
              last: $last,
              before: $before,
            ) {
              edges {
                node {
                  dimensions {
                    attribute
                  }
                  applied
                  notApplicable
                  total
                  unknown
                }
              }

              totalCount

              pageInfo {
                endCursor
                hasNextPage
                hasPreviousPage
                startCursor
              }
            }
          }
        }
      }
    }
  }
`);
